import React from 'react';
import * as PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { ButtonContainer } from 'components/button/button-container';
import { Button } from 'components/button';
import { withTranslation } from 'react-i18next';
import { viewRangeSelector } from 'common/selectors/integration';
import { RESPONSIVE_RANGES } from 'utils/enums';

const FormControls = (p) => (
  <ButtonContainer>
    {!p.isMobile && (
      <Button onClick={p.toggleFormAction} secondary={true}>
        {p.t('cancel')}
      </Button>
    )}

    <Button type={'submit'} disabled={p.pristine || p.submitting || p.invalid || p.adding}>
      {p.t('submit')}
    </Button>
  </ButtonContainer>
);

const mapStateToProps = (state, ownProps) => {
  const range = viewRangeSelector(state);
  const isMobile = range === RESPONSIVE_RANGES.MOBILE_SMALL || range === RESPONSIVE_RANGES.MOBILE_LARGE;

  return {
    isMobile,
  };
};

const FormControlsDecorated = compose(withTranslation(), connect(mapStateToProps))(FormControls);

FormControlsDecorated.propTypes = {
  toggleFormAction: PropTypes.func.isRequired,
};

export { FormControlsDecorated };
